import { CountryId } from '@/domain/models/country'
import { IdentityInfoContext } from '@/main/contexts'
import { useContext } from 'react'

export const useCountry = (): CountryId => {
  const {countryId} = useContext(IdentityInfoContext)

  return countryId
}
